import { RegistrationMessageResult } from './registration-message-result.enum';

export interface RegistrationResult {
  message: RegistrationMessageResult;
  offerReference?: string;
  firstPayment?: number;
}
